var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"aria-label":"Shift planner navigation"}},[_c('AppTabs',{attrs:{"design":"new","refined":"","weight":"medium","tabs":_vm.tabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }